// store/permissions.js
import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useQuery } from '@vue/apollo-composable';

import { useUserStore } from './user';
import { useProjectStore } from './project';

import ListRolePermissions from '@/gql/user/ListRolePermissions.gql';

export const usePermissionsStore = defineStore(
  'permissions',
  () => {
    const projectStore = useProjectStore();

    const permissions = ref([]);

    function fetchPermissions() {
      return new Promise((resolve, reject) => {
        const { onResult, onError } = useQuery(ListRolePermissions);
        onResult(({ data }) => {
          if (data && data.permissions) {
            permissions.value = [...data.permissions];
            resolve();
          }
        });
        onError((error) => {
          reject(error);
        });
      });
    }

    function hasPermission(permission) {
      const permissionId = permission;
      const roleId = projectStore.currentProjectRole; // ADMIN, DEVELOPER, FINANCE, READONLY
      return permissions.value.some(
        (v) => v.permission_id === permissionId && v.role_id === roleId
      );
    }

    function getRolesWithPermission(permission) {
      const permissionId = permission;
      return permissions.value
        .filter((v) => v.permission_id === permissionId)
        .map((v) => v.role_id);
    }

    function reset() {
      permissions.value = [];
    }

    return {
      permissions,
      hasPermission,
      fetchPermissions,
      reset,
      getRolesWithPermission,
    };
  },
  { persist: true }
);
